var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "shop-setting pad30 seller-style"
    },
    [
      _c("div", { staticClass: "f18 fb mar20-b" }, [_vm._v("店铺设置")]),
      _c("div", { staticClass: "pad20 mar20-b shop-card radius5" }, [
        _c("div", { staticClass: "f16 fb" }, [_vm._v("基础设置")]),
        _c("div", { staticClass: "flex items-center pad10 border-b mar5-b" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "w300" },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.changeShippingType },
                  model: {
                    value: _vm.shippingType,
                    callback: function($$v) {
                      _vm.shippingType = $$v
                    },
                    expression: "shippingType"
                  }
                },
                [
                  _c("el-checkbox", { attrs: { label: 1 } }, [
                    _vm._v("买家自提")
                  ]),
                  _c("el-checkbox", { attrs: { label: 0 } }, [
                    _vm._v("卖家配送")
                  ])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm.enableSelfPickUpTimeType
          ? _c(
              "div",
              { staticClass: "flex items-center pad10 border-b mar5-b" },
              [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "w300" },
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "0" },
                        model: {
                          value: _vm.selfPickupTimeType,
                          callback: function($$v) {
                            _vm.selfPickupTimeType = $$v
                          },
                          expression: "selfPickupTimeType"
                        }
                      },
                      [_vm._v("买家选择期望提货时间")]
                    ),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "1" },
                        model: {
                          value: _vm.selfPickupTimeType,
                          callback: function($$v) {
                            _vm.selfPickupTimeType = $$v
                          },
                          expression: "selfPickupTimeType"
                        }
                      },
                      [_vm._v("店铺确认可提货时间(买家下单无需选择提货时间)")]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm.shopDtlRule.receiptConfirmation === 1
          ? _c(
              "div",
              { staticClass: "flex items-center pad10 border-b mar5-b" },
              [
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "w300" },
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#1890ff",
                        "active-value": 1,
                        "inactive-value": 0
                      },
                      on: { change: _vm.handleCheckboxSel },
                      model: {
                        value: _vm.isReceiptConfirmation,
                        callback: function($$v) {
                          _vm.isReceiptConfirmation = $$v
                        },
                        expression: "isReceiptConfirmation"
                      }
                    }),
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              disabled: _vm.isReceiptConfirmation === 0
                            },
                            model: {
                              value:
                                _vm.checkboxSel.isReceiptConfirmationByGoods,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.checkboxSel,
                                  "isReceiptConfirmationByGoods",
                                  $$v
                                )
                              },
                              expression:
                                "checkboxSel.isReceiptConfirmationByGoods"
                            }
                          },
                          [_vm._v(" 应用全部货品")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "pad20 mar20-b shop-card radius5" }, [
        _c("div", { staticClass: "f16 fb" }, [_vm._v("支付设置")]),
        _c("div", { staticClass: "flex items-center pad10 border-b mar5-b" }, [
          _vm._m(3),
          _c(
            "div",
            { staticClass: "w300" },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.paymentMethod,
                    callback: function($$v) {
                      _vm.paymentMethod = $$v
                    },
                    expression: "paymentMethod"
                  }
                },
                [
                  _c("el-checkbox", { attrs: { label: 0 } }, [
                    _vm._v("在线支付")
                  ]),
                  _c("el-checkbox", { attrs: { label: 1 } }, [
                    _vm._v("线下结算")
                  ])
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "flex items-center pad10 border-b mar5-b" }, [
          _vm._m(4),
          _c(
            "div",
            { staticClass: "w300" },
            [
              _c("el-input", {
                staticClass: "w240",
                attrs: {
                  min: "0",
                  max: "100",
                  type: "number",
                  placeholder: "请输入最小比例"
                },
                model: {
                  value: _vm.shopDtlEntity.firstPaymentRatioMin,
                  callback: function($$v) {
                    _vm.$set(_vm.shopDtlEntity, "firstPaymentRatioMin", $$v)
                  },
                  expression: "shopDtlEntity.firstPaymentRatioMin"
                }
              }),
              _vm._v("%\n      ")
            ],
            1
          )
        ]),
        _vm.shopDtlRule.setWxFee === 1
          ? _c(
              "div",
              { staticClass: "flex items-center pad10 border-b mar5-b" },
              [
                _vm._m(5),
                _c(
                  "div",
                  { staticClass: "w300" },
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#1890ff",
                        "active-value": 1,
                        "inactive-value": 0
                      },
                      on: { change: _vm.handleCheckboxSel },
                      model: {
                        value: _vm.shopDtlEntity.isSetWxFee,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDtlEntity, "isSetWxFee", $$v)
                        },
                        expression: "shopDtlEntity.isSetWxFee"
                      }
                    }),
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              disabled: _vm.shopDtlEntity.isSetWxFee === 0
                            },
                            model: {
                              value: _vm.checkboxSel.isSetWxFeeByGoods,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.checkboxSel,
                                  "isSetWxFeeByGoods",
                                  $$v
                                )
                              },
                              expression: "checkboxSel.isSetWxFeeByGoods"
                            }
                          },
                          [_vm._v(" 应用全部货品")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm.shopDtlRule.fastPayment === 1
          ? _c(
              "div",
              { staticClass: "flex items-center pad10 border-b mar5-b" },
              [
                _vm._m(6),
                _c(
                  "div",
                  { staticClass: "w300" },
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#1890ff",
                        "active-value": 1,
                        "inactive-value": 0
                      },
                      on: { change: _vm.handleCheckboxSel },
                      model: {
                        value: _vm.isFastPayment,
                        callback: function($$v) {
                          _vm.isFastPayment = $$v
                        },
                        expression: "isFastPayment"
                      }
                    }),
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { disabled: _vm.isFastPayment === 0 },
                            model: {
                              value: _vm.checkboxSel.isFastPaymentByGoods,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.checkboxSel,
                                  "isFastPaymentByGoods",
                                  $$v
                                )
                              },
                              expression: "checkboxSel.isFastPaymentByGoods"
                            }
                          },
                          [_vm._v(" 应用全部货品")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm.shopDtlRule.alipay === 1
          ? _c(
              "div",
              { staticClass: "flex items-center pad10 border-b mar5-b" },
              [
                _c("div", { staticClass: "flex-auto" }, [
                  _c("div", { staticClass: "fb f15" }, [_vm._v("支付宝支付")]),
                  _vm.isAccStauts === 1
                    ? _c("div", { staticClass: "f12" }, [
                        _vm._v(
                          "编辑货品可选择支付宝支付，需承担手续费：0.6%（活动期费率）"
                        )
                      ])
                    : _c(
                        "div",
                        { staticClass: "f12" },
                        [
                          _vm._v(
                            "\n          编辑货品可选择支付宝支付，需承担手续费：0.6%（活动期费率）\n          "
                          ),
                          _c(
                            "el-link",
                            {
                              attrs: { type: "danger" },
                              on: { click: _vm.windowOpenPay }
                            },
                            [_vm._v("立即申请")]
                          )
                        ],
                        1
                      )
                ]),
                _vm.isAccStauts === 1
                  ? _c(
                      "div",
                      {
                        staticClass: "w300",
                        on: { change: _vm.handleCheckboxSel }
                      },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#1890ff",
                            "active-value": 1,
                            "inactive-value": 0
                          },
                          model: {
                            value: _vm.isalipay,
                            callback: function($$v) {
                              _vm.isalipay = $$v
                            },
                            expression: "isalipay"
                          }
                        }),
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: { disabled: _vm.isalipay === 0 },
                                model: {
                                  value: _vm.checkboxSel.isAlipayByGoods,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.checkboxSel,
                                      "isAlipayByGoods",
                                      $$v
                                    )
                                  },
                                  expression: "checkboxSel.isAlipayByGoods"
                                }
                              },
                              [_vm._v(" 应用全部货品")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _c(
        "div",
        { staticClass: "pad20 mar20-b shop-card radius5" },
        [
          _c("div", { staticClass: "f16 fb" }, [_vm._v("其他设置")]),
          _vm.shopDtlRule.supportInvoice === 1
            ? _c(
                "div",
                { staticClass: "flex items-center pad10 border-b mar5-b" },
                [
                  _vm._m(7),
                  _c(
                    "div",
                    { staticClass: "w300" },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#1890ff",
                          "active-value": 1,
                          "inactive-value": 0
                        },
                        model: {
                          value: _vm.shopDtlEntity.isSupportInvoice,
                          callback: function($$v) {
                            _vm.$set(_vm.shopDtlEntity, "isSupportInvoice", $$v)
                          },
                          expression: "shopDtlEntity.isSupportInvoice"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.shopDtlRule.zzInvoice === 1
            ? _c(
                "div",
                { staticClass: "flex items-center pad10 border-b mar5-b" },
                [
                  _vm._m(8),
                  _c(
                    "div",
                    { staticClass: "w300" },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#1890ff",
                          "active-value": 1,
                          "inactive-value": 0
                        },
                        model: {
                          value: _vm.isZzinvoice,
                          callback: function($$v) {
                            _vm.isZzinvoice = $$v
                          },
                          expression: "isZzinvoice"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.shopDtlRule.othersGoodsReceipt === 1
            ? _c(
                "div",
                { staticClass: "flex items-center pad10 border-b mar5-b" },
                [
                  _vm._m(9),
                  _c(
                    "div",
                    { staticClass: "w300" },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#1890ff",
                          "active-value": 1,
                          "inactive-value": 0
                        },
                        model: {
                          value: _vm.shopDtlEntity.isOthersGoodsReceipt,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.shopDtlEntity,
                              "isOthersGoodsReceipt",
                              $$v
                            )
                          },
                          expression: "shopDtlEntity.isOthersGoodsReceipt"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.shopDtlRule.enabledContract === 1
            ? [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center pad10 mar5-b",
                    class: { "border-b": !_vm.shop.isEnabledContract }
                  },
                  [
                    _vm._m(10),
                    _c(
                      "div",
                      { staticClass: "w300" },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#1890ff",
                            "active-value": 1,
                            "inactive-value": 0
                          },
                          on: { change: _vm.handleCheckboxSel },
                          model: {
                            value: _vm.shop.isEnabledContract,
                            callback: function($$v) {
                              _vm.$set(_vm.shop, "isEnabledContract", $$v)
                            },
                            expression: "shop.isEnabledContract"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm.shop.isEnabledContract
                  ? _c(
                      "div",
                      { staticClass: "mar20-lr pad10 radius10 mar268-r bg2" },
                      [
                        _vm._l(_vm.categoryOptionsList, function(item, index) {
                          return [
                            _c(
                              "el-checkbox",
                              {
                                key: item.templateType,
                                model: {
                                  value: item.checked,
                                  callback: function($$v) {
                                    _vm.$set(item, "checked", $$v)
                                  },
                                  expression: "item.checked"
                                }
                              },
                              [_vm._v(_vm._s(item.templateName))]
                            ),
                            _vm.shop.isEnabledContract === 1
                              ? _c("el-cascader", {
                                  key: index,
                                  ref: "enabledContract" + index,
                                  refInFor: true,
                                  staticClass: "w100-full mar10-b",
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    options:
                                      item.templateType == "CG-NXKH" ||
                                      item.templateType == "CG-KLMY" ||
                                      item.templateType == "CG-YR"
                                        ? _vm.options
                                        : _vm.optionsHasDisabled,
                                    "show-all-levels": false,
                                    props: _vm.props,
                                    disabled: !item.checked
                                  },
                                  on: {
                                    "visible-change": function(visible) {
                                      return _vm.focusContractCategory(
                                        item,
                                        visible
                                      )
                                    },
                                    change: function($event) {
                                      return _vm.changeContractCategory(index)
                                    }
                                  },
                                  model: {
                                    value: item.categoryIds,
                                    callback: function($$v) {
                                      _vm.$set(item, "categoryIds", $$v)
                                    },
                                    expression: "item.categoryIds"
                                  }
                                })
                              : _vm._e()
                          ]
                        }),
                        _vm.shop.isEnabledContract === 1
                          ? _c(
                              "el-checkbox",
                              {
                                staticClass: "block",
                                attrs: {
                                  disabled: _vm.shop.isEnabledContract === 0
                                },
                                model: {
                                  value:
                                    _vm.checkboxSel.isCategoryOptionsByGoods,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.checkboxSel,
                                      "isCategoryOptionsByGoods",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "checkboxSel.isCategoryOptionsByGoods"
                                }
                              },
                              [
                                _c("div", { staticClass: "flex flex-column" }, [
                                  _vm._v(
                                    "合同品类移除，是否移除合同模板中已应用在该品类下的商品"
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.shopDtlRule.materialStatement === 1
            ? _c(
                "div",
                { staticClass: "flex items-center pad10 border-b mar5-b" },
                [
                  _vm._m(11),
                  _c(
                    "div",
                    { staticClass: "w300" },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#1890ff",
                          "active-value": 1,
                          "inactive-value": 0
                        },
                        model: {
                          value: _vm.shopDtlEntity.isSignMaterialStatement,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.shopDtlEntity,
                              "isSignMaterialStatement",
                              $$v
                            )
                          },
                          expression: "shopDtlEntity.isSignMaterialStatement"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "flex items-center pad10 border-b mar5-b" },
            [
              _vm._m(12),
              _c(
                "div",
                { staticClass: "w300" },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-color": "#1890ff",
                      "active-value": 1,
                      "inactive-value": 0
                    },
                    model: {
                      value: _vm.qlwSycCustomer,
                      callback: function($$v) {
                        _vm.qlwSycCustomer = $$v
                      },
                      expression: "qlwSycCustomer"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "flex items-center pad10 border-b mar5-b" },
            [
              _vm._m(13),
              _c(
                "div",
                { staticClass: "w300" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择服务人员"
                      },
                      model: {
                        value: _vm.helpdeskBoId,
                        callback: function($$v) {
                          _vm.helpdeskBoId = $$v
                        },
                        expression: "helpdeskBoId"
                      }
                    },
                    _vm._l(_vm.helpdeskList, function(item) {
                      return _c("el-option", {
                        key: item.boId,
                        attrs: {
                          label: item.name + "-" + item.tel,
                          value: item.boId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "flex items-center pad10 border-b mar5-b" },
            [
              _vm._m(14),
              _c(
                "div",
                { staticClass: "w300" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择短信接收人员"
                      },
                      model: {
                        value: _vm.smsBoId,
                        callback: function($$v) {
                          _vm.smsBoId = $$v
                        },
                        expression: "smsBoId"
                      }
                    },
                    _vm._l(_vm.helpdeskList, function(item) {
                      return _c("el-option", {
                        key: item.boId,
                        attrs: {
                          label: item.name + "-" + item.tel,
                          value: item.boId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        2
      ),
      _vm.shopDtlRuleNew && _vm.shopDtlRuleNew.length > 0
        ? _c(
            "div",
            { staticClass: "pad20 mar20-b shop-card radius5" },
            [
              _c("div", { staticClass: "f16 fb" }, [_vm._v("扩展设置")]),
              _vm._l(_vm.shopDtlRuleNew, function(dtlRule) {
                return [
                  dtlRule.status === 1
                    ? _c(
                        "div",
                        {
                          key: dtlRule.parentBusType,
                          staticClass: "flex items-center pad10 border-b mar5-b"
                        },
                        [
                          _c("div", { staticClass: "flex-auto" }, [
                            _c("div", { staticClass: "fb f15" }, [
                              _vm._v(_vm._s(dtlRule.name))
                            ]),
                            _c("div", { staticClass: "f12" })
                          ]),
                          _c(
                            "div",
                            { staticClass: "w300" },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#1890ff",
                                  "active-value": 1,
                                  "inactive-value": 0
                                },
                                model: {
                                  value: dtlRule.value,
                                  callback: function($$v) {
                                    _vm.$set(dtlRule, "value", $$v)
                                  },
                                  expression: "dtlRule.value"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex justify-center pad20-t" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("配送方式：")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("设置卖家支持的配送方式，买家提交订单时可选")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("自提时间：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("收货确认")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("可选择货品是否支持配置收货确认")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("支付方式：")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("配置买家提交订单时可选择的支付方式")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("首次支付最小比例：")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("配置多次支付首次支付的最小比例")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("微信支付")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("编辑货品可选择微信支付，需承担手续费："),
        _c("span", { staticClass: "red" }, [_vm._v("0.63%")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("银行卡支付")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("编辑货品可选择银行卡支付，需承担手续费：储蓄卡"),
        _c("span", { staticClass: "red" }, [_vm._v("0.3%")]),
        _vm._v("，信用卡"),
        _c("span", { staticClass: "red" }, [_vm._v("0.6%")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("开具发票")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("配置买家提交订单时可选择的是否开具发票")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("开具增值税专用发票")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("配置买家提交订单时可选择的是否开具增值税专用发票")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("是否可邀请人收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("签署合同")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("配置买家购买商品后是否需要签订合同")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("大宗原料确认书")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("配置买卖双方是否签订大宗原料结算确认书")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("自动创建客户档案")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("开启自动创建客户档案功能，用户下单后自动创建客户档案")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("店铺客服人员")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("选择接收买家在线咨询信息人员，只能选择[权限设置列表中的人员]")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-auto" }, [
      _c("div", { staticClass: "fb f15" }, [_vm._v("店铺短信接收人员")]),
      _c("div", { staticClass: "f12" }, [
        _vm._v("选择接收店铺相关短信人员，只能选择[权限设置列表中的人员]")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }